import Header from "../components/header";
import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  <Header />;
  return (
    <div className="bg-[#F2F1F6] py-8 lg:py-16 lg:px-12 px-4">
      <h1 className="mb-10 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl  text-[#E79014] text-center">
        Privacy Policy
      </h1>
      <div className="text-gray-700">
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          This Privacy Policy ("Policy") outlines how Matching Master ("we,"
          "us," or "our") collects, uses, and protects your personal information
          when you use our mobile application ("App").
        </p>
        {/* <h2 className="mb-8 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Information We Collect:
        </h2> */}
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Information You Provide Directly:
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          When you create an account or interact with the App, you may provide
          the following personal information:
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold">Account Information:</span> Name, email
          address, username, and password when you create an account to access
          certain features of the App.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> In-App Purchases: </span> Payment
          information, billing address, and other details necessary to process
          any premium content purchases or subscriptions.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> Game Progress: </span> Data related to
          your performance, preferences, and settings within the App, such as
          the mode you play, levels you have completed, and difficulty settings.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Information Collected Automatically:
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We collect certain information automatically when you use the App,
          including:
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold">Usage Data:</span> Information about how
          you interact with the App, such as the features you use, the time and
          duration of your sessions, and gameplay activity (e.g., levels played,
          achievements earned).
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> Device Information:</span> Data about
          the device you use to access the App, including device type, operating
          system, unique device identifiers, IP address, and browser type.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> Crash and Error Reports: </span> We may
          collect technical information related to app crashes or other errors
          to help improve the App's performance and fix issues.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Use of Your Information
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We use the information we collect for various purposes, including:
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> To Operate and Provide the App: </span>{" "}
          To facilitate gameplay, user accounts, and access to different modes
          like Quick Game, Stage Mode, etc.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> To Improve the App: </span> To
          facilitate gameplay, user accounts, and access to different modes like
          Quick Game, Stage Mode, etc.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> To Provide Customer Support: </span>
          To respond to your inquiries and provide assistance if needed.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> To Process In-App Purchases: </span>
          To complete any transactions for premium levels or other paid
          features, if applicable.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          <span className="font-bold">To Send Promotional Communications:</span>
          With your consent, to send notifications about updates, new levels, or
          promotions.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          - <span className="font-bold"> To Analyze Usage: </span>
          To understand how users interact with the App and improve its
          functionality and user experience.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Sharing of Your Information
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We may share your information with trusted third-party service
          providers who assist us in operating the App, processing payments, and
          improving functionality. These third parties are obligated to keep
          your information confidential and secure. We will not share your
          personally identifiable information (PII) with any third party for
          marketing purposes without your explicit consent.
        </p>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We may also disclose your information if required to do so by law,
          regulation, or legal process (e.g., a subpoena), or if we believe that
          such action is necessary to protect our rights, the safety of others,
          or to prevent fraud.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Data Retention
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We will retain your information for as long as your account is active
          or as necessary to provide the services you have requested. We may
          retain certain information for legal or compliance reasons even after
          your account is closed or inactive.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Security
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We take reasonable measures to protect your information from
          unauthorized access, alteration, disclosure, or destruction. This
          includes implementing technical, administrative, and physical
          safeguards. However, no method of electronic storage or transmission
          over the internet is completely secure, and we cannot guarantee
          absolute security.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Your Choices
        </h2>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Access and Update Your Information
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          You have the right to access and update your account information at
          any time by logging into your account. You can modify or delete your
          profile details, change settings, and adjust preferences.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Unsubscribe from Marketing Communications
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          You may opt out of receiving marketing communications from us by
          following the unsubscribe instructions included in each email or by
          updating your communication preferences in the app.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Deleting Your Account
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If you wish to delete your account, you can do so by contacting our
          support team or through your account settings. Upon deletion, we may
          retain certain information as required by law or for legitimate
          business purposes.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Children's Privacy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Matching Master is not intended for children under the age of 13. We
          do not knowingly collect personal information from children under 13.
          If you are a parent or guardian and believe your child has provided us
          with personal information, please contact us immediately. We will take
          steps to remove that information from our systems.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Contact Us
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If you have any questions or concerns about this Privacy Policy or how
          we handle your data, please contact us at:
          <a
            href="mailto:info@thekaizenglobal.com"
            className=" text-[#E79014] hover:underline"
          >
            {" "}
            info@thekaizenglobal.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
